<template>
<div id="app">

<div class="content-header">
  <h1>用户列表</h1>
</div>

<div class="app-container">


  <el-table size="small" current-row-key="id" :data="dataList" stripe highlight-current-row>
    <el-table-column type="index" align="center" label="id"></el-table-column>
    <el-table-column prop="fileId" label="文件id" align="center"></el-table-column>
    <el-table-column prop="versionCode" label="版本号" align="center"></el-table-column>
    <el-table-column prop="versionName" label="版本名" align="center"></el-table-column>
    <el-table-column prop="affectVersionCode" label="受影响版本号" align="center"></el-table-column>
    <el-table-column prop="apkUrl" label="Url" align="center"></el-table-column>
    <el-table-column prop="updateContent" label="描述" align="center"></el-table-column>
    <el-table-column prop="status" label="状态" align="center"></el-table-column>
    <el-table-column prop="type" label="类型" align="center"></el-table-column>
    <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
    <el-table-column prop="createUser" label="创建用户" align="center"></el-table-column>

  </el-table>


</div>

</div>

</template>

<script>
import axios from "@/wifiaxios";
const wifiaxios = axios.create({
  baseURL:"http://localhost:9081/sight"
})
export default {
  name: 'ApksInfo',
  data: function(){
    return {
      dataList: []//当前页要展示的列表数据
    }
  },

  //钩子函数，VUE对象初始化完成后自动执行
  mounted() {
    //调用查询全部数据的操作
    this.getAll();
  },

  methods: {
    getAll() {
      axios.get("/sys/app/version/info").then((res)=>{
        console.log(res.data);
        this.dataList = res.data.data;
      });

    }
  }
}

</script>
